import { GraphType } from "utils/enums/graph";
import React from "react";
import { totalLabelForGraph } from "utils/helper";

interface ICustomLegendProps {
  totalEnrolments: number;
  colorValueMap: Record<string, string>;
  graphType: GraphType;
}

const CustomLegend: React.FC<ICustomLegendProps> = (props) => {
  const { totalEnrolments, colorValueMap, graphType } = props;

  return (
    <div className="custom-legend">
      {/* CATEGORIES WITH COLOR-VALUE PAIRS */}
      <div>
        {Object.entries(colorValueMap).map(([category, color]) => (
          <span key={category} className="custom-legend-categories">
            <svg width="16" height="16" style={{ marginRight: 5 }}>
              <rect width="16" height="16" fill={color} rx="3" />
            </svg>
            {category}
          </span>
        ))}
      </div>
      {/* TOTAL ENROLMENT COUNT */}
      <div className="custom-legend-enrolment-count">
        <span
          style={{
            fontWeight: "bold",
            fontSize: 20,
            marginRight: 6,
          }}
        >
          {totalEnrolments}
        </span>
        <span
          style={{
            color: "#757575",
            fontSize: 17,
            fontWeight: 450,
          }}
        >
          {totalLabelForGraph(graphType)}
        </span>
      </div>
    </div>
  );
};

export default CustomLegend;
